var PubSub = require("underpub-js");

var Timeline1 = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

};

Timeline1.prototype.init = function(){

  var self = this;

  this.offsetTimelineItems();

  window.onload = function() {
    self.offsetTimelineItems();
  };

  // on window resize
  PubSub.subscribe("resized", function(){
    self.offsetTimelineItems();
  });

};

Timeline1.prototype.offsetTimelineItems = function() {

  var self = this;

  var $timelineWrap = this.options.$el.find('.timeline-grid');

  if (!(window.Breakpoint.value == "xsmall" || window.Breakpoint.value == "small"))
  {

    // this block aligns the right side timeline items
    // it works by setting margin-top relative to the left side items height
    this.options.$el.find('.timeline-column:nth-child(2n + 2)').each(function() {

      var prevHeight = $(this).prev('.timeline-column').find('.timeline-item').outerHeight();
      var newTop = prevHeight; // - 90

      $(this).css('margin-top', newTop + 'px');

    });

    // adjust height of timeline grid to account for top offsets of timeline itemsw in css
    var numTimelineItems = this.options.$el.find('.timeline-column').length;

    // reset height to auto, then get height of timeline wrap
    $timelineWrap.css('height', 'auto');
    var timelineWrapHeight = $timelineWrap.outerHeight();

    // subtract 90px from the height for each timeline item (not counting the first one)
    var newTimelineWrapHeight = timelineWrapHeight - ((numTimelineItems - 1) * 90);

    $timelineWrap.css('height', newTimelineWrapHeight + 'px');

  }
  else
  {
    // reset the timeline columns for mobile
    $('.timeline-column').css('margin-top', '0px');
    $timelineWrap.css('height', 'auto');
  }

};

module.exports = Timeline1;
